let id = 0;

export function createUniqueId(prefix = 'uid_'): string {
  return `${prefix}${id++}`;
}
